export default __webpack_public_path__ + "static/media/about-laptop.257f9df1.png";